import React, { useState } from 'react';
// @Mui
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import LoginIcon from '@mui/icons-material/Login';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import { Paper } from '@mui/material';
import { ConnectKitButton } from 'connectkit';

import { Box } from '@mui/system';
import { useAccount } from 'wagmi';
import { useLocation, Link } from 'react-router-dom';
import { SideBarData } from '../../utils/components-data';

// ----------------------------------------------------------------------

const BottomNav = () => {
  // eslint-disable-next-line no-unused-vars
  const [value, setValue] = useState(0);
  const { isConnected } = useAccount();
  const { pathname } = useLocation();

  return (
    <Paper
      sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999999 }}
      elevation={3}
    >
      <BottomNavigation
        sx={{ bgcolor: 'grey.900' }}
        showLabels
        value={pathname}
        onChange={(e, newVal) => {
          setValue(newVal);
        }}
      >
        {SideBarData.map(({ icon, id, name, path }) => (
          <BottomNavigationAction
            component={Link}
            to={path}
            value={path}
            key={id}
            label={name}
            icon={<Box>{icon}</Box>}
          />
        ))}
        <BottomNavigationAction
          label={isConnected ? 'logout' : 'login'}
          icon={
            <ConnectKitButton.Custom>
              {({ isConnected, show }) => (
                <Box onClick={show}>
                  {isConnected ? <AccountBoxIcon /> : <LoginIcon />}
                </Box>
              )}
            </ConnectKitButton.Custom>
          }
        />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
